import axios from "axios";

export const circulationSupply = async () => {
    try {
        const { data } = await axios.get("https://tifi.net/api/tifi_circulation_supply")
        return data;

    } catch (error) {
        console.log('Failed to get APY data', error);
    }
};

export const getTotalHolders = async () => {
    try {
        const { data } = await axios.get(`https://tifi.net/api//tifi_holders_count`);
        return data;
    } catch (error) {
        console.error('Failed to get APY data', error);
    }
};

export const getTradingVolume = async () => {
    try {
        const response = await axios.get('https://tifi.net/api/prices/TIFI');
        return response.data.quote.USD.volume_24h;
    } catch (error) {
        console.error('Failed to get trading volume', error);
    }
}